import React from 'react';
import FormsListItem from './FormsListItem';
import { useTranslation } from 'react-i18next';
import { ErrorHandler } from '../../ErrorHandler';

const FormsList = ({ items = [] }) => {
    const { i18n } = useTranslation();

    return (
        <article className="product__article-item">
            {items.length ?
                <ul className="product__list product__list_form">
                    {items.map(it => (
                        <li key={it.id}
                            className={`product__list-item ${it.isDeleted ? 'product__list-item_deleted' : ''}`}>
                            <FormsListItem form={it} />
                        </li>
                    ))}
                </ul>
                :
                <ErrorHandler titleValue={i18n.t('app.page.profile.emptyData')}/>}
        </article>
    );
};

export default FormsList;
